import { IBreadcrumbItem, PanelType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import {
  IconButton,
  iconButtonStylesNoBG,
  IPageHeaderProps,
  IPanelProps,
  PageHeader,
  pageHeaderStylesSecondary,
  Panel,
  useClassNames,
} from '@h2oai/ui-kit';
import { useEffect } from 'react';

import { ContentsTitle, defaultPanelWidth } from '../../featurestore/models';
import { Ingest } from '../Ingest/Ingest';
import { IIngestPanelClassNames, IIngestPanelStyles, ingestPanelStylesDefault } from './IngestPanel.styles';

const getBreadcrumbItems = (name: string): IBreadcrumbItem[] => {
  return [
    { text: `${ContentsTitle.featureSet}: ${name}`, key: `${ContentsTitle.featureSet} ${name}` },
    {
      text: ContentsTitle.ingest,
      key: ContentsTitle.ingest,
      isCurrentItem: true,
    },
  ];
};

interface IIngestPanelProps {
  featureSetName?: string;
  featureSetId?: string;
  featureSetVersion?: string;
  show: boolean;
  onDismiss: (
    ev?: KeyboardEvent | React.SyntheticEvent<HTMLElement, Event> | undefined,
    updated?: boolean,
    isOnline?: boolean
  ) => void;
}

export const IngestPanel = ({
  featureSetName = '',
  featureSetId,
  featureSetVersion,
  show,
  onDismiss,
}: IIngestPanelProps) => {
  const [isOpen, { setTrue: open, setFalse: close }] = useBoolean(false);
  const panelProps: IPanelProps = {
    type: PanelType.custom,
    customWidth: defaultPanelWidth,
    isOpen,
    onDismiss: () => onDismiss(),
    isFooterAtBottom: true,
    hasCloseButton: false,
  };

  const pageHeaderProps: IPageHeaderProps = {
    pageTitle: ContentsTitle.ingest,
    styles: pageHeaderStylesSecondary,
    breadcrumbProps: {
      items: getBreadcrumbItems(featureSetName),
    },
    actions: <IconButton styles={iconButtonStylesNoBG} iconName="Clear" onClick={() => onDismiss()} />,
  };

  useEffect(() => {
    if (show) {
      open();
    } else {
      close();
    }
  }, [show]);
  const classNames = useClassNames<IIngestPanelStyles, IIngestPanelClassNames>('IngestPanel', ingestPanelStylesDefault);
  return (
    <Panel {...panelProps} data-test="ingest-panel">
      <div className={classNames.root}>
        <PageHeader {...pageHeaderProps} />
        <Ingest
          featureSetVersion={featureSetVersion}
          featureSetId={featureSetId}
          onSave={(isOnline) => onDismiss(undefined, true, isOnline)}
          onCancel={onDismiss}
        />
      </div>
    </Panel>
  );
};
